import { r as D } from "./common-Cd7R8f1s.js";
import { n as p } from "./Logger-CmiOOsKC.js";
var x = "morphbake_", C = "bevel_", I = "text3d_", w = ".glb";
function re(r) {
  return `${x}${r}${w}`;
}
function ne(r, e) {
  return `${C}${r}_${e}${w}`;
}
var se = "builtin:none";
function oe(r) {
  return `${I}${r}${w}`;
}
var M = {
  deformation: x,
  bevel: C,
  text: I
};
function z(r) {
  if (typeof r != "string") return;
  const e = r.split(/[?#]/, 1)[0], t = e.slice(e.lastIndexOf("/") + 1);
  if (t.endsWith(w))
    return Object.keys(M).find((n) => t.startsWith(M[n]));
}
function j(r) {
  return z(r) !== void 0;
}
function ie(r, e, t, n, o) {
  if (t.isPlayMode()) return r;
  const s = L(r, e);
  if (s === void 0) return r;
  if (s === "") {
    p.debug(`[restoreBakedSrc] "${n ?? "?"}": authoring load, its behaviors build what was baked as ${String(r)}`);
    return;
  }
  if (o !== void 0 && r) {
    let i = A.get(t);
    i || A.set(t, i = /* @__PURE__ */ new Map()), i.set(o, r);
  }
  return p.debug(`[restoreBakedSrc] "${n ?? "?"}": authoring load, opening ${s} instead of the baked ${String(r)}`), s;
}
function L(r, e) {
  if (!j(r)) return;
  const t = Z(e)?.bakedFrom;
  if (!(typeof t != "string" || !t || t === r))
    return t === "builtin:none" ? "" : t;
}
var m = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ new WeakMap();
function S(r) {
  let e = m.get(r);
  return e || (e = { generation: 0 }, m.set(r, e)), e;
}
function ae(r, e) {
  const t = r.uid === void 0 ? void 0 : A.get(e), n = r.uid === void 0 ? void 0 : t?.get(r.uid);
  if (!n || typeof r.src != "string") return;
  t.delete(r.uid);
  const o = S(r);
  o.current = {
    src: n,
    rig: r.src,
    kinds: N(r),
    generation: o.generation
  }, o.written = void 0;
}
function $(r) {
  const e = m.get(r);
  e && e.generation++;
}
function ce(r) {
  return {
    rig: r.src ?? "",
    kinds: N(r),
    generation: S(r).generation
  };
}
function le(r, e, t) {
  S(r).written = {
    uri: e,
    ...t
  };
}
function de(r) {
  const e = m.get(r)?.current;
  return e && e.rig === r.src ? e.src : void 0;
}
function ue(r, e) {
  const t = m.get(r);
  t?.current && (t.current = {
    ...t.current,
    kinds: e.kinds,
    generation: e.generation
  });
}
function he(r, e) {
  const t = m.get(r);
  if (!t) return;
  const n = t.written, o = n && e(n.uri);
  n && o && (t.current = {
    src: o,
    rig: n.rig,
    kinds: n.kinds,
    generation: n.generation,
    stored: n.uri
  }, t.written = void 0);
  const s = t.current;
  if (!(!s || s.rig !== r.src || s.kinds !== N(r))) {
    if (s.stored !== void 0 && e(s.stored) !== s.src) {
      t.current = void 0;
      return;
    }
    return s.generation === t.generation ? s.src : void 0;
  }
}
function N(r) {
  return r.getBehaviors().map((e) => e.name).join(",");
}
function Z(r) {
  return (r ?? []).find((e) => !!e && typeof e == "object" && e["@type"] === "Provenance");
}
var K = [
  [/(?<![!=<>])=(?!=)/g, "Assignment is not allowed in expressions"],
  [/\b(if|else|for|while|do|switch|return|throw|try|catch|finally|var|let|const|class|function|import|export)\b/g, "Statements are not allowed in expressions"],
  [/\bnew\b/g, "`new` is not allowed in expressions"],
  [/\bdelete\b/g, "`delete` is not allowed in expressions"],
  [/\btypeof\b/g, "`typeof` is not allowed in expressions"],
  [/\bvoid\b/g, "`void` is not allowed in expressions"],
  [/\b(window|document|globalThis|process|eval)\b/g, "Global access is not allowed in expressions"],
  [/`/g, "Template literals are not allowed in expressions"],
  [/=>/g, "Arrow functions are not allowed in expressions"],
  [/\[/g, "Array literals/access is not allowed in expressions"],
  [/\{/g, "Object literals are not allowed in expressions"]
];
function X(r) {
  const e = [];
  for (const [t, n] of K)
    t.lastIndex = 0, t.test(r) && e.push(n);
  return e;
}
var T = {
  floor: Math.floor,
  ceil: Math.ceil,
  round: Math.round,
  abs: Math.abs,
  sign: Math.sign,
  sqrt: Math.sqrt,
  pow: Math.pow,
  min: Math.min,
  max: Math.max,
  clamp: (r, e, t) => Math.max(r, Math.min(t, e)),
  lerp: (r, e, t) => r + (e - r) * t,
  map: (r, e, t, n, o) => {
    const s = t - e;
    return s === 0 ? n : n + (o - n) * ((r - e) / s);
  },
  smoothstep: (r, e, t) => {
    const n = e - r;
    if (n === 0) return 0;
    const o = Math.max(0, Math.min(1, (t - r) / n));
    return o * o * (3 - 2 * o);
  },
  sin: Math.sin,
  cos: Math.cos,
  tan: Math.tan,
  atan2: Math.atan2,
  random: (r, e) => r === void 0 ? Math.random() : e === void 0 ? Math.random() * r : r + Math.random() * (e - r)
}, y = /* @__PURE__ */ new Map(), k = /* @__PURE__ */ new Map(), B = /* @__PURE__ */ new Map();
function F(r) {
  const e = y.get(r);
  if (e !== void 0) return e;
  const t = X(r);
  if (t.length > 0)
    return p.warn(`[Expression] Invalid expression "${r}": ${t.join(", ")}`), y.set(r, null), k.set(r, t.join(", ")), null;
  try {
    const n = H(r);
    return y.set(r, n), n;
  } catch (n) {
    return p.warn(`[Expression] Failed to compile "${r}":`, n), y.set(r, null), k.set(r, n instanceof Error ? n.message : String(n)), null;
  }
}
function H(r) {
  const e = W(r), t = (s) => {
    const i = e.filter(s), c = i.length ? `var ${i.map((u) => `${u} = $scope[${JSON.stringify(u)}]`).join(", ")};` : "";
    return new Function("$scope", `${c} return (${r});`);
  }, n = t(() => !1);
  if (e.length === 0) return n;
  const o = /* @__PURE__ */ new Map([[0, n]]);
  return (s) => {
    let i = 0, c = "";
    for (let a = 0; a < e.length; a++)
      e[a] in s && (a < 31 ? i |= 1 << a : c += `${a},`);
    const u = c ? `${i}|${c}` : i;
    let l = o.get(u);
    return l || (l = t((a) => a in s), o.set(u, l)), l(s);
  };
}
var V = /* @__PURE__ */ new Set([
  "true",
  "false",
  "null",
  "undefined",
  "NaN",
  "Infinity",
  "this",
  "in",
  "instanceof",
  "of",
  "$scope",
  "break",
  "case",
  "catch",
  "class",
  "const",
  "continue",
  "debugger",
  "default",
  "delete",
  "do",
  "else",
  "enum",
  "export",
  "extends",
  "finally",
  "for",
  "function",
  "if",
  "import",
  "new",
  "return",
  "super",
  "switch",
  "throw",
  "try",
  "typeof",
  "var",
  "void",
  "while",
  "with"
]);
function W(r) {
  const e = r.replace(/'(?:\\.|[^'\\])*'|"(?:\\.|[^"\\])*"/g, '""'), t = /* @__PURE__ */ new Set();
  for (const n of e.matchAll(/(?<![\w$])(?<!(?<!\.)\.)([A-Za-z_$][\w$]*)/g)) V.has(n[1]) || t.add(n[1]);
  return [...t];
}
function J(r, e) {
  const t = F(r);
  if (!t) return {
    ok: !1,
    code: "invalid-expression",
    message: k.get(r) ?? "Expression could not be compiled"
  };
  try {
    return {
      ok: !0,
      value: t(e)
    };
  } catch (n) {
    return {
      ok: !1,
      code: "evaluation-error",
      message: n instanceof Error ? n.message : String(n)
    };
  }
}
function G(r, e) {
  try {
    return r(e);
  } catch (t) {
    p.warn("[Expression] Evaluation error:", t);
    return;
  }
}
var q = /* @__PURE__ */ new Set([
  ...Object.keys(T),
  "true",
  "false",
  "null",
  "undefined",
  "NaN",
  "Infinity",
  "PI",
  "E"
]);
function P(r) {
  const e = B.get(r);
  if (e) return e;
  const t = [], n = /\b([a-zA-Z_][a-zA-Z0-9_]*)\b/g;
  let o;
  for (; (o = n.exec(r)) !== null; ) {
    const i = o[1];
    q.has(i) || t.push(i);
  }
  const s = Object.freeze([...new Set(t)]);
  return B.set(r, s), s;
}
var _ = /^(?:\$([a-zA-Z_][a-zA-Z0-9_]*)|\{([a-zA-Z_][a-zA-Z0-9_]*)\})$/, R = /^\{([^{}]+)\}$/, b = /(?<!\{)\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g, v = /(?<!\{)\{([^}]*[^a-zA-Z0-9_}][^}]*)\}/g;
function E(r) {
  return r[1] ?? r[2];
}
function fe(r) {
  return _.test(r) || /(?<!\{)\{[^{}]+\}/.test(r);
}
function pe(r) {
  const e = typeof r == "string" ? r.match(_) : null;
  return e ? E(e) : null;
}
function O(r) {
  return /^[a-zA-Z_][a-zA-Z0-9_]*$/.test(r);
}
function Y(r) {
  let e = !1;
  for (let t = 0; t < r.length; t++) {
    const n = r[t];
    if (!(n !== "{" && n !== "}")) {
      if (!e && r[t + 1] === n) {
        t++;
        continue;
      }
      if (n === "{" && e) return !0;
      e = n === "{";
    }
  }
  return !1;
}
function Q(r, e) {
  if (r.size !== e.size) return !1;
  for (const t of r) if (!e.has(t)) return !1;
  return !0;
}
function U(r, e) {
  let t = r;
  for (; t; ) {
    const n = t.getBehavior("Properties");
    if (n?.hasProperty(e)) return n;
    t = t.getParent();
  }
  return null;
}
var me = class d {
  get name() {
    return this._authored["@type"];
  }
  sceneObject;
  _authored;
  _resolved;
  _propertyNames = /* @__PURE__ */ new Set();
  _hasEscapedBraces = !1;
  get _literalData() {
    return this.constructor.literalData === !0;
  }
  _rescanPropertyNames() {
    this._propertyNames = this._literalData ? /* @__PURE__ */ new Set() : d._scanPropertyNames(this._authored), this._hasEscapedBraces = this._literalData ? !1 : d._containsEscapedBraces(this._authored);
  }
  attachedNode = null;
  constructor(e, t) {
    this.sceneObject = e, this._authored = structuredClone(t), this._rescanPropertyNames(), this._resolved = this._resolveAll();
  }
  static _scanPropertyNames(e) {
    const t = /* @__PURE__ */ new Set();
    return d._walkForRefs(e, t), t;
  }
  static _containsEscapedBraces(e) {
    return typeof e == "string" ? e.includes("{{") || e.includes("}}") : Array.isArray(e) ? e.some((t) => d._containsEscapedBraces(t)) : e !== null && typeof e == "object" ? Object.values(e).some((t) => d._containsEscapedBraces(t)) : !1;
  }
  static _walkForRefs(e, t) {
    if (typeof e == "string") {
      const n = e.match(_);
      if (n) {
        t.add(E(n));
        return;
      }
      const o = e.match(R);
      if (o) {
        for (const c of P(o[1])) t.add(c);
        return;
      }
      const s = e.replaceAll("{{", "\0\0").replaceAll("}}", "");
      let i;
      for (b.lastIndex = 0; (i = b.exec(s)) !== null; ) t.add(i[1]);
      for (v.lastIndex = 0; (i = v.exec(s)) !== null; ) for (const c of P(i[1])) t.add(c);
      return;
    }
    if (Array.isArray(e)) {
      for (const n of e) d._walkForRefs(n, t);
      return;
    }
    if (e !== null && typeof e == "object") for (const n of Object.keys(e)) d._walkForRefs(e[n], t);
  }
  _resolveAll() {
    return this._propertyNames.size === 0 && !this._hasEscapedBraces ? structuredClone(this._authored) : d._resolveValue(this._authored, this.sceneObject);
  }
  static _resolveValue(e, t) {
    if (typeof e == "string") {
      const n = e.match(_);
      if (n) {
        const s = E(n), i = t.resolveProperty(s);
        return i !== void 0 ? i : e;
      }
      const o = e.match(R);
      if (o && !O(o[1])) return d._evaluateExpr(o[1], t) ?? e;
      if (e.includes("{")) {
        const s = e.replaceAll("{{", "\0").replaceAll("}}", "");
        b.lastIndex = 0;
        let i = s.replace(b, (c, u) => {
          const l = t.resolveProperty(u);
          return l !== void 0 ? typeof l == "object" ? JSON.stringify(l) : String(l) : c;
        });
        return v.lastIndex = 0, i = i.replace(v, (c, u) => {
          const l = d._evaluateExpr(u, t);
          return l !== void 0 ? typeof l == "object" ? JSON.stringify(l) : `${l}` : c;
        }), i.replaceAll("\0", "{").replaceAll("", "}");
      }
      return e;
    }
    if (Array.isArray(e)) return e.map((n) => d._resolveValue(n, t));
    if (e !== null && typeof e == "object") {
      const n = {};
      for (const o of Object.keys(e)) n[o] = d._resolveValue(e[o], t);
      return n;
    }
    return e;
  }
  static _evaluateExpr(e, t) {
    const n = F(e);
    if (n)
      return G(n, d._expressionScope(e, t));
  }
  static _expressionScope(e, t) {
    const n = t.traceScene?.getSystemValues(), o = {
      ...n ? n.buildScope(t.transform) : {},
      ...T
    };
    for (const s of P(e)) {
      const i = t.resolveProperty(s);
      i !== void 0 && (o[s] = i);
    }
    return o;
  }
  getBindingDiagnostics(e = 50) {
    if (this._literalData) return [];
    const t = [], n = this.sceneObject, o = (s, i) => {
      if (t.length >= e) return;
      if (Array.isArray(s)) {
        s.forEach((a, h) => o(a, `${i}[${h}]`));
        return;
      }
      if (s && typeof s == "object") {
        for (const [a, h] of Object.entries(s)) o(h, `${i}.${a}`);
        return;
      }
      if (typeof s != "string" || D.has(s)) return;
      if (Y(s)) {
        t.push({
          object: n.getPath(),
          behavior: this.name,
          field: i,
          source: s,
          code: "nested-braces",
          message: "A binding opens inside another, so neither evaluates: write one {…} and group with parentheses, e.g. {a + (b ? 1 : 0)}"
        });
        return;
      }
      const c = s.match(_), u = s.replaceAll("{{", "\0").replaceAll("}}", ""), l = c ? [E(c)] : [...u.matchAll(/\{([^{}]+)\}/g)].map((a) => a[1]);
      for (const a of l) {
        if (t.length >= e) break;
        let h, f;
        if (O(a))
          h = n.resolveProperty(a), h === void 0 && (f = {
            code: "missing-property",
            message: `No property named "${a}" resolves from this object`
          });
        else {
          const g = J(a, d._expressionScope(a, n));
          g.ok ? h = g.value : f = {
            code: g.code,
            message: g.message
          };
        }
        !f && h == null && (f = {
          code: "unresolved-value",
          message: "Binding evaluated to no value"
        }), !f && typeof h == "number" && !Number.isFinite(h) && (f = {
          code: "non-finite",
          message: "Binding evaluated to NaN or infinity"
        }), !f && /\.transform\.(position|rotation|scale)\[\d+\]$/.test(i) && !Number.isFinite(Number(h)) && (f = {
          code: "invalid-transform",
          message: "Transform component did not resolve to a finite number"
        }), f && t.push({
          object: n.getPath(),
          behavior: this.name,
          field: i,
          source: s,
          ...f
        });
      }
    };
    return o(this._authored, "$"), t;
  }
  getAuthored() {
    return this._authored;
  }
  _replaceAuthored(e) {
    this._authored = e, this._rescanPropertyNames(), this._resolved = this._resolveAll();
  }
  getData() {
    return structuredClone(this._authored);
  }
  _getResolvedData() {
    return this._resolved;
  }
  async commit(e) {
    return this._applyCommit(e, !1);
  }
  async commitSnapshot(e) {
    return this._applyCommit(e, !0);
  }
  async _applyCommit(e, t) {
    const n = structuredClone(this._authored), o = this._propertyNames, s = this._resolved;
    t ? this._authored = structuredClone(e) : Object.assign(this._authored, e);
    const i = this.validate(this._authored);
    if (i.length > 0)
      return this._authored = n, i;
    this._rescanPropertyNames(), this._resolved = this._resolveAll();
    const c = !Q(o, this._propertyNames);
    c && this._subscribeToProperties(), $(this.sceneObject);
    try {
      await this.applyCommit(e, n);
    } catch (u) {
      const l = u instanceof Error ? u.message : String(u);
      p.error(`[${this.constructor.name}] applyCommit failed: ${l}`), this._authored = n, this._propertyNames = o, this._resolved = s, c && this._subscribeToProperties();
      try {
        this.onCommitRolledBack();
      } catch (a) {
        p.warn(`[${this.constructor.name}] onCommitRolledBack failed: ${String(a)}`);
      }
      return [{
        message: l,
        code: "APPLY_FAILED"
      }];
    }
    return [];
  }
  async applyCommit(e, t) {
  }
  onCommitRolledBack() {
  }
  serialize() {
    return structuredClone(this._authored);
  }
  validate(e) {
    return [];
  }
  get scene() {
    return this.sceneObject.babylonScene;
  }
  get resources() {
    return this.sceneObject.resources;
  }
  init() {
  }
  load() {
  }
  attach(e) {
    this.attachedNode = e, this._subscribeToProperties(), this.onAttach(e), this._subscribePlayMode();
  }
  detach() {
    this._unsubscribePlayMode(), this._unsubscribeFromProperties(), this.onDetach(), this.attachedNode = null;
  }
  onAttach(e) {
  }
  onDetach() {
  }
  onPlayModeChanged(e) {
  }
  onPointerEvent(e, t) {
  }
  claimsSelect() {
    return !1;
  }
  wantsDescendantPointerEvents() {
    return !1;
  }
  onDescendantPointerEvent(e, t, n) {
    return !1;
  }
  onEffectiveActiveChanged(e) {
  }
  _onEffectiveActiveChanged(e) {
    this.onEffectiveActiveChanged(e);
  }
  get playMode() {
    return this.sceneObject.traceScene.isPlayMode();
  }
  onAnimationRootCreated(e) {
  }
  onParentFrameChanged(e, t) {
  }
  _subscribedProperties = /* @__PURE__ */ new Map();
  _subscribeToProperties() {
    if (this._unsubscribeFromProperties(), this._propertyNames.size !== 0)
      for (const e of this._propertyNames) {
        const t = U(this.sceneObject, e);
        t && (t.subscribe(e, this), this._subscribedProperties.set(e, t));
      }
  }
  _unsubscribeFromProperties() {
    for (const [e, t] of this._subscribedProperties) t.unsubscribe(e, this);
    this._subscribedProperties.clear();
  }
  _resubscribeAndResolve() {
    if (this._propertyNames.size === 0) return;
    this._subscribeToProperties();
    const { patch: e, hasChanges: t } = this._reresolve();
    t && this._applyResolvedPatch(e);
  }
  _onPropertyChanged(e) {
    const { patch: t, hasChanges: n } = this._reresolve();
    n && this._applyResolvedPatch(t);
  }
  _reresolve() {
    const e = this._resolved;
    this._resolved = this._resolveAll();
    const t = {};
    let n = !1;
    for (const o of Object.keys(this._resolved)) {
      if (o === "@type") continue;
      const s = e[o], i = this._resolved[o];
      JSON.stringify(s) !== JSON.stringify(i) && (t[o] = i, n = !0);
    }
    return {
      patch: t,
      hasChanges: n
    };
  }
  _applyResolvedPatch(e) {
    $(this.sceneObject), this.applyCommit(e, this._authored).catch((t) => p.warn(`[${this.name}] applyCommit failed during property change:`, t));
  }
  _playModeHandler = null;
  _subscribePlayMode() {
    if (this.onPlayModeChanged === d.prototype.onPlayModeChanged) return;
    const e = this.sceneObject.traceScene.getEventSystem();
    e && (this._playModeHandler = (t) => {
      const n = t.detail?.playMode;
      this.onPlayModeChanged(n);
    }, e.addEventListener("trace-viewer:playmode-changed", this._playModeHandler), this.sceneObject.traceScene.isPlayMode() && this.onPlayModeChanged(!0));
  }
  _unsubscribePlayMode() {
    if (!this._playModeHandler) return;
    const e = this.sceneObject.traceScene.getEventSystem();
    e && e.removeEventListener("trace-viewer:playmode-changed", this._playModeHandler), this._playModeHandler = null;
  }
};
export {
  oe as C,
  de as S,
  re as _,
  fe as a,
  $ as b,
  F as c,
  ae as d,
  ie as f,
  ne as g,
  L as h,
  U as i,
  G as l,
  ce as m,
  _ as n,
  E as o,
  z as p,
  pe as r,
  T as s,
  me as t,
  se as u,
  j as v,
  he as w,
  le as x,
  ue as y
};

//# sourceMappingURL=tracebehavior-5_qSKjs6.js.map